/**
 * Home page public data — supabase.rpc (active categories, top listings).
 */
import { createClient } from "@/lib/supabase/client";
import type { CategoryPublic } from "@/repositories/category.repository";

export interface TopListingCard {
  id: string;
  name: string;
  category: string;
  price: number;
  weeklyPrice?: number | null;
  brand?: string | null;
  model?: string | null;
  condition: string;
  location: string;
  features: string[];
  image?: string | null;
  rating?: number;
  reviews?: number;
  owner: {
    name: string;
    avatar_url?: string | null;
    rating: number;
    reviews: number;
  };
  period: string;
}

export async function fetchActiveCategoriesRpc(): Promise<CategoryPublic[]> {
  const supabase = createClient();
  // eslint-disable-next-line @typescript-eslint/no-explicit-any -- RPC not in generated Database types yet
  const { data, error } = await supabase.rpc("get_active_categories_public" as any);
  if (error) throw error;
  if (data == null) return [];
  return Array.isArray(data) ? (data as CategoryPublic[]) : [];
}

export async function fetchTopListingsForHomeRpc(
  limit: number,
  userId?: string | null
): Promise<{ listings: TopListingCard[] }> {
  const supabase = createClient();
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const { data, error } = await supabase.rpc("get_top_listings_for_home", {
    p_limit: limit,
    p_user_id: userId ?? null,
  } as any);
  if (error) throw error;
  const row = data as { listings: TopListingCard[] } | null;
  return { listings: row?.listings ?? [] };
}
